<template>
  <div class="supporters">
    <div class="title row column-s">
      <div class="grid-8-m grid-9-g grid-12-s text-center-s row align-center">
        <i class="fa fa-users"></i>&nbsp; MINHA EQUIPE &nbsp;
        <Button
          v-if="!showNewSupporter"
          layout="green-go"
          @click="showNewSupporter = !showNewSupporter"
          >NOVO TÉCNICO</Button
        >
        <Button
          v-if="showNewSupporter"
          class="hide-s"
          layout="red-go"
          @click="showNewSupporter = !showNewSupporter"
          >FECHAR</Button
        >
      </div>
      <div class="grid-3-g grid-4-m grid-12-s row">
        <div class="search fa">
          <input type="text" placeholder="Buscar" v-model="search" />
        </div>
      </div>
    </div>
    <form
      class="form row column-s grid-12 grid-11-s justify-space align-center"
      v-if="showNewSupporter"
      onsubmit="return false;"
      @submit="newAggregate()"
    >
      <div class="row grid-12 justify-end font-20 hide-m hide-g">
        <i
          class="fa fa-times text-red"
          @click="showNewSupporter = !showNewSupporter"
        ></i
        ><br />
      </div>
      <div class="column grid-3 grid-12-s font-12">
        <label for>Nome completo:</label>
        <input
          class="input"
          type="text"
          v-model="newSupporter.nome"
          placeholder="Nome"
          pattern="(\w.+\s).+"
          title="Informar nome completo"
          required
        />
      </div>
      <br />
      <div class="column grid-3 grid-12-s font-12">
        <label for>E-mail:</label>
        <input
          class="input"
          v-model="newSupporter.email"
          type="email"
          placeholder="E-mail"
          required
        />
      </div>
      <br />

      <div class="column grid-2 grid-12-s font-12">
        <label for>CPF:</label>
        <input
          class="input"
          v-model="newSupporter.cpf"
          type="text"
          placeholder="CPF"
          required
          v-mask="'###.###.###-##'"
        />
      </div>
      <br />
      <div class="column grid-2 grid-12-s font-12">
        <label for>RG:</label>
        <input
          class="input"
          type="text"
          v-model="newSupporter.rg"
          placeholder="RG"
          required
        />
      </div>
      <br />

      <Button layout="green-go" :loader="loaderButton">CADASTRAR</Button>
    </form>
    <ul v-if="!loader" class="column list">
      <div class="row label hide-s">
        <div class="grid-1">ID</div>
        <div class="grid">NOME</div>
        <div class="grid">EMAIL</div>
        <div class="grid">CPF</div>
        <div class="grid">RG</div>
        <div class="grid-1 text-center-m text-center-g">VALIDADO</div>
        <div class="grid-1 text-center-m text-center-g">STATUS</div>
        <div class="grid-2"></div>
      </div>
      <li
        v-for="(client, i) of filteredClients"
        :key="'supporter' + i"
        class="column"
      >
        <div class="row column-s line align-center align-baseline-s">
          <div class="grid-1 grid-12-s id">
            <span class="hide-m hide-g">ID: </span>
            <b>{{ client.id }}</b>
          </div>
          <br />
          <div class="grid grid-12-s">
            <b class="hide-m hide-g">NOME: </b>
            <input
              type="text"
              class="input"
              v-model="filteredClients[i].nome"
              v-if="client.edit"
            /><span v-else>{{ client.nome }}</span>
          </div>
          <div class="grid grid-12-s">
            <b class="hide-m hide-g">E-MAIL: </b>
            <input
              type="text"
              class="input grid-12-s"
              v-model="filteredClients[i].email"
              v-if="client.edit"
            /><span v-else>{{ client.email }}</span>
          </div>
          <div class="grid grid-12-s">
            <b class="hide-m hide-g">CPF: </b>
            <input
              type="text"
              class="input"
              v-model="filteredClients[i].cpf"
              v-if="client.edit"
            /><span v-else>{{ client.cpf }}</span>
          </div>
          <div class="grid grid-12-s">
            <b class="hide-m hide-g">RG: &nbsp; </b>
            <input
              type="text"
              class="input"
              v-model="filteredClients[i].rg"
              v-if="client.edit"
            /><span v-else>{{ client.rg }}</span>
          </div>
          <div class="grid-1 grid-12-s text-center-m text-center-g">
            <b class="hide-m hide-g">CADASTRO VALIDADO: </b>
            {{ client.cadastro_validado ? "Sim" : "Não" }}
          </div>
          <br />
          <div
            class="grid-1 grid-12-s text-center"
            :class="client.status == 'ativo' ? 'text-green' : 'text-red'"
          >
            <b>{{ client.status }}</b>
          </div>
          <br /><br />
          <div
            class="
              grid-2 grid-12-s
              row
              justify-end justify-center-s
              align-center
              controls
            "
          >
            <div title="EDITAR" class="pointer" v-if="client.status == 'ativo'">
              <i
                v-if="!client.edit"
                class="fa fa-edit font-18"
                @click="edit(filteredClients[i])"
              ></i>
            </div>

            <div v-if="client.edit">
              <Button
                layout="green-go"
                @click="updateSupporter(filteredClients[i])"
                >Atualizar</Button
              >
              &nbsp;
              <Button layout="red-go" @click="edit(filteredClients[i])"
                >Cancelar</Button
              >
            </div>
            <div
              class="pointer text-red font-20"
              title="DESATIVAR TÉCNICO"
              v-if="client.status == 'ativo'"
            >
              <i
                @click="inactiveAggregate(filteredClients[i])"
                class="fa fa-power-off"
              ></i>
            </div>
            <!-- <div
              class="pointer text-green font-20"
              title="ATIVAR TÉCNICO"
              v-if="client.status == 'inativo'"
            >
              <i
                @click="activateAggregate(filteredClients[i])"
                class="fa fa-power-off"
              ></i>
            </div> -->
          </div>
        </div>
      </li>
    </ul>
    <div v-else class="column align-center justify-center">
      <Loader />
    </div>

    <Modal :modal="modal" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Button from "@/components/Button.vue";
import Loader from "@/components/Loader.vue";
import Format from "@/utils/format";
import Modal from "@/components/Modal.vue";
import Vue from "vue";
import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);

export default {
  name: "Clients",
  components: { Button, Loader, Modal },
  data() {
    return {
      loader: true,
      loaderButton: false,
      search: "",
      supporters: [],
      showNewSupporter: false,
      newSupporter: {
        nome: "",
        email: "",
        rg: "",
        cpf: "",
      },
      modal: {
        show: false,
        layout: "MySupporters",
        title: "MINHA EQUIPE",
        description:
          "Agora você pode cadastrar seus técnicos e delegar jobs a eles.",
      },
    };
  },
  beforeMount() {
    this.loadSupporters();
  },
  methods: {
    ...mapActions("admin", [
      "AGGREGATE_SUPPORTER_LIST",
      "NEW_AGGREGATE_SUPPORTER",
      "DEL_AGGREGATE_SUPPORTER",
      "UPDATE_SUPPORTER",
      "ACTIVATE_AGGREGATE",
    ]),
    nextSlide(n) {
      this.slide = {
        1: false,
        2: false,
        3: false,
      };
      if (n) {
        this.slide[n] = true;
        this.count = n + 1;
      } else this.slide[this.count++] = true;
    },
    loadSupporters() {
      this.AGGREGATE_SUPPORTER_LIST().then((r) => {
        this.supporters = r.data;
        this.loader = false;
      });
    },
    edit(supporter) {
      supporter.edit = !supporter.edit;
      this.$forceUpdate();
    },
    updateSupporter(supporter) {
      this.UPDATE_SUPPORTER(supporter).then(() => {
        this.loadSupporters();
        supporter.edit = false;
      });
    },
    newAggregate() {
      this.loaderButton = true;
      this.newSupporter.cpf = Format.clear(this.newSupporter.cpf);
      this.NEW_AGGREGATE_SUPPORTER({
        ...this.newSupporter,
      }).then((r) => {
        this.loadSupporters();
        this.loaderButton = false;
        if (r.status == 200 || r.status == 201) {
          this.newSupporter = {
            nome: "",
            email: "",
            rg: "",
            cpf: "",
          };
        }
      });
    },
    inactiveAggregate(client) {
      if (confirm("Deseja mesmo desativar este técnico?")) {
        this.DEL_AGGREGATE_SUPPORTER({
          id: client.id,
          del: true,
          notRedirect: true
        }).then((r) => {
          if (r.status == 200 || r.status == 201) {
            this.loadSupporters();
          }
        });
      }
    },
    activateAggregate(client) {
      this.ACTIVATE_AGGREGATE(client.id).then((r) => {
        if (r.status == 200 || r.status == 201) {
          this.loadSupporters();
        }
      });
    },
    searchAggregate(client) {
      this.aggregateLoader = true;
      let filter = client.aggregate.search.includes("@")
        ? { email: client.aggregate.search }
        : { nome: client.aggregate.search };
      this.AGGREGATE_LIST({ id_cliente: client.id, ...filter })
        .then((r) => {
          client.aggregate.list = r.data;
          this.$forceUpdate();
          this.aggregateLoader = false;
        })
        .catch(() => {
          client.aggregate.list = null;
          this.aggregateLoader = false;
        });
    },
    mask(client) {
      client.aggregate.celular = Format.phone(client.aggregate.celular);
      this.$forceUpdate();
    },
  },
  mounted() {
    this.$parent.$children[0].changeMenu("mysupporters");
    if (
      !localStorage.getItem("equipe") ||
      localStorage.getItem("equipe") !== "false"
    )
      this.modal.show = true;
  },
  computed: {
    ...mapGetters("user", ["user"]),

    filteredClients() {
      if (this.search) {
        const search = this.search.toLowerCase();

        return this.supporters.filter((client) => {
          const clientsSerialize = JSON.stringify(client).toLowerCase();
          return clientsSerialize.includes(search);
        });
      } else {
        return this.supporters || [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.supporters {
  padding: 42px 35px;
  @media (max-width: $small) {
    padding: 7px;
  }

  .title {
    font-size: 24px;
    font-weight: bold;
    color: $gray-4;
    text-transform: uppercase;

    @media (max-width: $small) {
      margin-top: 38px;
      margin-bottom: 0px;
    }

    .search {
      height: 35px;
      width: 100%;
      border-bottom: 1px solid $white-4;
      @media (max-width: $medium) {
        margin-top: 15px;
      }
      input {
        border: none;
        padding: 5px 7px;
        background: none;
        width: 92%;

        &:focus {
          background: none !important;
          box-shadow: 0 0 0 0;
          border: 0 none;
          outline: 0;
        }
      }

      &:after {
        content: "\f002";
        color: $white-4;
        position: absolute;
        margin-left: -25px;
        margin-top: 3px;
      }
    }
  }
  .form {
    background: #fff;
    border-radius: 7px;
    padding: 10px;
    box-shadow: $shadow;
    margin-top: 25px;
  }
  .status,
  .controls {
    font-weight: bold;
    i {
      margin-left: 15px;
    }
    &.green,
    .green {
      color: $green-1;
    }
    &.blue,
    .blue {
      color: $blue-3;
    }
    &.red,
    .red {
      color: $red-3;
    }
    button {
      margin-bottom: 5px;
      @media (max-width: $large) {
        font-size: 12px;
      }
    }
  }
  .list {
    margin-top: 25px;

    .label {
      font-weight: bold;
      color: #aaa;
      padding: 14px 10px;
      font-size: 15px;
      @media (max-width: $small) {
        font-size: 12px;
      }
    }
    li {
      color: $gray-6;
      background: $white;
      border-radius: 4px;
      margin-bottom: 7px;
      box-shadow: $shadow;
      font-size: 14px;
      border: 2px solid $white;

      .line {
        padding: 14px 10px;
        input {
          width: 90%;
          @media (max-width: $small) {
            margin-bottom: 15px;
            width: 95%;
          }
        }
      }
      .id {
        color: $blue-5;
      }
      .status {
        div {
          font-weight: bold;
          border-radius: 50%;
          font-size: 14px;
          width: 22px;
          height: 20px;
          text-align: center;
          line-height: 22px;
        }
        span {
          color: $red-1;
          margin-left: 15px;
          font-weight: 300;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }

      .aggregate {
        margin-top: 5px;
        padding: 20px 10px;
        border-top: 1px solid #ddd;
        /*   background: $gray-5; */

        &-new-button {
          font-size: 12px;
          width: 125px;
          height: 32px;
        }

        &-import {
          background: #f1f1f1;
          padding: 20px;
          margin-top: 20px;
          border: 3px dashed #ccc;
          border-radius: 5px;

          p {
            line-height: 20px;
          }

          &-button {
            font-size: 12px;
            width: 200px;
            height: 32px;
            margin-left: 10px;
          }

          .filler {
            background: $green-8;
            height: 10px;
            padding-left: 10px;
            color: $gray-4;
            font-size: 12px;

            font-weight: bold;
          }
          .field {
            margin-top: 20px;
            height: 10px;
            background: #bbb;
            border: 1px solid #dbdbdb;
            border-radius: 10px;
            overflow: hidden;
            opacity: 1;
            width: 230px;
          }
        }

        &-new-form {
          padding: 7px;
          margin: 15px 0px;
          input {
            @media (min-width: $small) {
              margin-right: 15px;
            }
            @media (max-width: $small) {
              margin-bottom: 20px;
            }
          }
        }
        &-list {
          margin-top: 20px;
          padding: 7px;
          .list {
            margin-top: 25px;
            li {
              padding: 10px;
              background: #f1f1f1;
              border: none;
              margin-bottom: 0px;

              .controls {
                .actions {
                  font-weight: 500;
                  .activate {
                    background: $green-2;
                  }
                  .del {
                    background: $red-1;
                  }
                  span {
                    width: 62px;
                    font-size: 13px;
                    text-align: center;
                    color: #fff;
                    padding: 3px 8px;
                    border-radius: 20px;
                    &:hover {
                      cursor: pointer;
                      box-shadow: $shadow;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .loader {
    margin-top: 8%;
  }
}
</style>